// @flow

// Note: those two import made the app crash. Why?
// So we save the account on the session and retrieve it.
// import RestaurantStore from 'stores/RestaurantStore';
// import ProAccountStore from '../stores/ProAccountStore';

// but this import works.. why?
// import SessionStore from 'stores/SessionStore';

import _ from 'lodash';

import {
  AdminPermissions,
  BookingPermissions,
  ExportPermissions,
  OrderSettingsPermissions,
  CartModifiersPermissions,
  ProAccountPermissions,
  RestaurantMenuPermissions,
  RestaurantSettingsPermissions
} from 'utils/permissions';

class SecurityContext {
  admin = new AdminPermissions();

  //
  // Roles for proRoles
  //

  proAccount = new ProAccountPermissions();

  //
  // Roles for booking
  //

  booking = new BookingPermissions();

  //
  // Restaurant Menu
  //

  restaurantMenu = new RestaurantMenuPermissions();

  //
  // Order
  //

  orderSettings = new OrderSettingsPermissions();

  cartModifiers = new CartModifiersPermissions();

  //
  // Restaurant settings
  //

  restaurantSettings = new RestaurantSettingsPermissions();

  export = new ExportPermissions();

  canEscaladePermission(permission: Function) {
    const allowed = [
      this.booking.canCancelBooking,
      this.booking.canCreateBookingOverLimit
    ];

    let res = false;

    _.each(allowed, (func) => {
      if (func === permission) {
        res = true;
        return false; // quit loop
      }
    });

    return res;
  }



}

const securityContextInstance = new SecurityContext();

export default securityContextInstance;
